/**
 * Page historique d'activite
 * Affiche les logs de securite et l'historique des actions du compte
 */

import { useNavigate } from 'react-router-dom';
import { useAuth, SecuritySettings } from '@features/auth';

export function HistoryPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!user) return null;

  return (
    <div className="flex justify-center">
      <SecuritySettings
        userId={user.id}
        show2FASection={false}
        showPasswordSection={false}
        onConfigure2FA={() => navigate('/dashboard/2fa')}
        onChangePassword={() => navigate('/dashboard/password')}
      />
    </div>
  );
}
